import Config from "../Config";
import Requisicao from "./RequisicaoService";

class LogradouroService {
    static async listar() {
        return Requisicao.get(Config.urlBaseApi + 'endereco/logradouro');
    }    
}

export default LogradouroService;